export default __webpack_public_path__ + "static/media/goodDay-tackle.c2b7d905.gif";